import { referralsConstants } from '../constants/referrals';

const initialState = {
  referrals: [],
  count: 0,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case referralsConstants.SET_REFERRALS_SUCCESS:
      return {
        referrals: action.referrals || [],
        count: action.count,
      };
    default:
      return state;
  }
};
